import QuestionLineIcon from '@raison/static/icons/question-line.svg';
import React from 'react';
import {InlineSvg} from '~/library/ui-kit';

export namespace Password {
    export const allowedSymbols = '~`!@#$%^&*()_+-={}[]\\|;:"\'<>,./?'.split('');

    const hasInvalidChars = (value: string) => {
        const onlySymbols = value.match(/[^a-zA-Z0-9]/g);

        for (const symbol of onlySymbols ?? []) {
            if (!allowedSymbols.includes(symbol)) {
                return true;
            }
        }

        return false;
    };

    export const criteria = [
        {
            name: '8-32 characters',
            check: ({length}) => length >= 8 && length <= 32,
            errorText: 'Incorrect number of characters',
        },
        {
            name: 'Lowercase letter',
            check: RegExp.prototype.test.bind(/[a-z]/),
            errorText: 'There is no lowercase letter',
        },
        {
            name: 'Uppercase letter',
            check: RegExp.prototype.test.bind(/[A-Z]/),
            errorText: 'There is no uppercase letter',
        },
        {
            name: 'Number',
            check: RegExp.prototype.test.bind(/[0-9]/),
            errorText: 'There is no number',
        },
    ] satisfies Array<{
        name: string;
        check: (password: string) => boolean;
        errorText: string;
    }>;

    export const validatePasswords = (mainInput: string, matchInput: string) => {
        const validations = criteria.map(c => ({...c, isMet: c.check(mainInput)}));
        const passwordsDoMatch = mainInput === matchInput;

        const validationErrors = validations.filter(criteria => !criteria.isMet).map(c => c.errorText);

        const getMainError = (onInvalidCharsHintClick?: () => void) => {
            switch (true) {
                case !mainInput:
                    return 'This field is required';
                case hasInvalidChars(mainInput):
                    return (
                        <span className='flex gap-1'>
                            <span>Symbol not allowed</span>
                            <button onClick={onInvalidCharsHintClick} className='flex h-4 items-center text-inherit'>
                                <InlineSvg src={QuestionLineIcon} className='size-3' />
                            </button>
                        </span>
                    );
                case validationErrors.length > 0:
                    return validationErrors[0];
                default:
                    return undefined;
            }
        };

        const getMatchError = () => {
            switch (true) {
                case !matchInput:
                    return 'This field is required';
                case !passwordsDoMatch:
                    return "Passwords don't match";
                default:
                    return undefined;
            }
        };

        const passwordIsValid = validationErrors.length === 0 && !getMainError() && !getMatchError();

        return {passwordsDoMatch, passwordIsValid, validations, getMainError, getMatchError};
    };
}
